import React from "react";
import Button from "../utils/Button";
import classes from "./CartRow.module.css";
import useShopStore from "../store/useShopStore";
import useAppStore from "../store/useAppStore";
import { toast } from "react-toastify";

import { useEffect } from "react";

const DECREASE_CART_QTY = -1;
const INCREASE_CART_QTY = +1;

export default function CartRow(props) {
  const { cart, updateCart, removeFromToCart } = useShopStore((state) => state);
  const handleClick = () => {
    removeFromToCart(props.id);

    useAppStore.setState({ notify: "Removed From Cart" });

    toast(useAppStore.getState().notify);
  };
  const increaseAmountHandler = () => {
    updateCart(props.id, INCREASE_CART_QTY);
  };
  const decreaseAmountHandler = () => {
    updateCart(props.id, DECREASE_CART_QTY);
  };

  useEffect(() => {}, [cart]);

  return (
    <div className={classes.cartProductContainer}>
      <div className={classes.cartProductImageContainer}>
        <img alt="cart" src={props.image} />
        <div className={classes.cartName}>{props?.name}</div>
      </div>
      <div className={classes.infoContainer}>
        <div className={classes.qtyContainer}>
          <Button disabled={+props.qty === 1} onClick={decreaseAmountHandler}>
            -
          </Button>
          <div className={classes.cartQty}>{props?.qty}</div>
          <Button onClick={increaseAmountHandler}>+</Button>
        </div>
        <div className={classes.cartPrice}>{props.price} EUR</div>
      </div>
      <Button onClick={handleClick}>Remove from Cart</Button>
    </div>
  );
}
